export default function labelize(str) {
  return str.replace(/_/g, " ").replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
}
